import { createContext, useContext } from 'react';
import { useImmerReducer } from 'use-immer';
import InsertChartOutlinedIcon from '@mui/icons-material/InsertChartOutlined';
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import DeleteIcon from '@mui/icons-material/Delete';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import PeopleIcon from '@mui/icons-material/People';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import { ReactComponent as IntegrationIcon } from '../../src/images/integration.svg'


const navInit = {
    isPageMenuOpen: true,
    marketplacePage: 'Dashboards',
    isEditMode: false,
    isMainSideBarExpanded: false,
    isMainSideBarHovered: false,
    userManagementOption: 'Users',
    accSelectedGroup: { id: 1, name: "All Accounts", Icon: AdminPanelSettingsIcon }, 
    userSelectedGroup: { id: 1, name: "All Users", Icon: PeopleIcon }, 
    toolpaneOption: 'Integrations',
    toolpanePages: [
      { title: "Integrations", icon: IntegrationIcon },
      { title: "Drafts", icon: InsertChartOutlinedIcon },
    ],
    accountGroups: [
      { id: 1, name: "All Accounts", Icon: AdminPanelSettingsIcon },
      { id: 2, name: "Trial", Icon: AdminPanelSettingsIcon },
      { id: 3, name: "Paid", Icon: AdminPanelSettingsIcon },
      { id: 4, name: "Inactive", Icon: ErrorOutlineIcon },
      { id: 5, name: "Trash", Icon: DeleteIcon },
    ],
    userGroups: [
      { id: 1, name: "All Users", Icon: PeopleIcon },
      { id: 2, name: "Requested to Join", Icon: PendingActionsIcon },
      { id: 3, name: "Invited Users", Icon: PeopleIcon },
      { id: 4, name: "Pending Deletion", Icon: PeopleIcon },
    ],
    onDashboardEditor: false
};

function navReducer ( draft, { type, payload } ) {
    switch (type) {
      case "togglePageMenu": {
        draft.isPageMenuOpen = !draft.isPageMenuOpen;
        break;
      }
      case "changeMarketplacePage": {
        draft.marketplacePage = payload;
        break;
      }
      case "toggleEditMode": {
        draft.isEditMode = !draft.isEditMode;
        break;
      }
      case "changeOption": {
        draft.userManagementOption = payload;
        break;
      }
      case "changeToolpaneOption": {
        draft.toolpaneOption = payload;
        break;
      }
      // payload: true or false
      case "setDashboardEditor": {
        draft.onDashboardEditor = payload
        break;
      }
      case "changeMainSideBarExpand": {
        draft.isMainSideBarExpanded = payload
        break;
      }
      case "changeHoaverOnMainSideBar": {
        draft.isMainSideBarHovered = payload
        break;
      }
      case "setAccSelectedGroup": {
        const { accountGroups } = draft;
        draft.accSelectedGroup = accountGroups.find((group) => group.id === payload.id);
        break;
      }
      case "setUserSelectedGroup": {
        const { userGroups } = draft;
        draft.userSelectedGroup = userGroups.find((group) => group.id === payload.id);
        break;
      }
      default: {
        return null;
      }
    }
}

const [NavContext,NavDispatchContext] = [createContext(null),createContext(null)];

export default function NavProvider ({ init, children }) {
    const [navStore, dispatch] = useImmerReducer(navReducer, init||navInit);

    return (
        <NavContext.Provider value={navStore}>
            <NavDispatchContext.Provider value={dispatch}>
                {children}
            </NavDispatchContext.Provider>
        </NavContext.Provider>
    )
}

export function useNavStore() {
    return useContext(NavContext);
}

export function useNavDispatch() {
    return useContext(NavDispatchContext);
}